import { render, staticRenderFns } from "./TaskDetailsTitleCircle.vue?vue&type=template&id=661afaa6&scoped=true"
import script from "./TaskDetailsTitleCircle.vue?vue&type=script&lang=ts"
export * from "./TaskDetailsTitleCircle.vue?vue&type=script&lang=ts"
import style0 from "./TaskDetailsTitleCircle.vue?vue&type=style&index=0&id=661afaa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661afaa6",
  null
  
)

export default component.exports